import ProductBulletPoints from './product-bullet-points';

export default ProductBulletPoints;